
import { defineComponent } from 'vue'
import SideBar from '@/components/SideBar.vue'

export default defineComponent({
    name: 'Costs',
    components: { SideBar }
})
